/**
 * Webform submit handler.
 *
 * @param form
 *   The form element containing the form.
 * @param token
 *   The recaptcha token.
 * @param formId
 *   An optional form id.
 * @param language
 *   An optional language.
 */
export function submitWebform(form: HTMLFormElement, token?: string, formId?: string, language?: string): Promise<Response> {
  const locale = language ?? 'en';
  const body = {'form_id': formId ?? form.id, 'recaptcha_token': token};
  const formData = new FormData(form);
  formData.forEach((val, key) => {
    if (val) body[key] = val
  });
  return fetch(`/api/webform-submit`, {
    method: "POST",
    headers: {"Content-Type": "application/json", "Accept-Language": `${locale}`},
    body: JSON.stringify(body),
  });
}

/**
 * Webform submit handler for forms whose state lives outside an HTMLFormElement
 * (e.g. React Hook Form). Posts the same body shape as `submitWebform`.
 *
 * @param data
 *   A flat object whose keys match the Drupal webform's element keys.
 * @param formId
 *   The Drupal webform id.
 * @param token
 *   The recaptcha token.
 * @param language
 *   An optional language.
 */
export function submitWebformJson(data: Record<string, any>, formId: string, token?: string, language?: string): Promise<Response> {
  const locale = language ?? 'en';
  const body: Record<string, any> = {form_id: formId, recaptcha_token: token};
  for (const [key, value] of Object.entries(data)) {
    if (value === undefined || value === null || value === "") continue;
    body[key] = value;
  }
  return fetch(`/api/webform-submit`, {
    method: "POST",
    headers: {"Content-Type": "application/json", "Accept-Language": `${locale}`},
    body: JSON.stringify(body),
  });
}